import { Directive, ElementRef, OnChanges, Renderer2, inject, input } from '@angular/core';
import { BrandingService } from './branding.service';

/*
 * Use this directive to set the src attribute of an image to the branded version of the image.
 * Example: <img brandingAssetSrc="icon/home-no-results.svg" /> will load the image from:
 * `/assets/brands/{brandName}/assets/icon/home-no-results.svg`
 */
@Directive({
  selector: '[brandingAssetSrc]',
  standalone: false,
})
export class BrandingAssetSrcDirective implements OnChanges {
  private readonly _elRef: ElementRef = inject(ElementRef);
  private readonly _renderer: Renderer2 = inject(Renderer2);
  private readonly brandingService: BrandingService = inject(BrandingService);

  readonly brandingAssetSrc = input<string>();

  ngOnChanges(): void {
    const srcUrl: string = `/assets/brands/${this.brandingService.brand()}/assets/${this.brandingAssetSrc()}`;
    this._renderer.setAttribute(this._elRef.nativeElement, 'src', srcUrl);
  }
}
